import React from "react";
import { Select, Tag } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { lang } from "../../constants/common.const";
import { FullTextTag } from "../../page/VideoManagement/FullTextTag";

const { Option } = Select;

const SelectWithTagAll = ({
  checkFull,
  listSelect,
  handleChange,
  value,
  valueFull,
  textFull,
  disabled
}) => {
  const renderOption = (list) => {
    return list.map((item) => (
      <Option key={item.key} value={item.key} disabled={item.disabled}>
        {item.label || item.value}
      </Option>
    ));
  };

  const tagRender = (menuCode) => (props) => {
    const { label, closable, onClose } = props;
    const onPreventMouseDown = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    if (checkFull) return <div></div>;

    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginRight: 3 }}
      >
        {label}
      </Tag>
    );
  };
  return (
    <div
      className={`wrap-select ${
        !checkFull ? "wrap-select-noborder" : "wrap-select-border"
      }`}
    >
      <Select
        tagRender={(props) => <FullTextTag {...props} />}
        dropdownClassName="custom-select-hover"
        optionFilterProp="children"
        showArrow
        showSearch
        className={`select w100 ${checkFull ? "noborder" : ""}`}
        maxTagCount={checkFull ? undefined : 5}
        style={{ border: "none" }}
        onChange={(value) => {
          handleChange(value);
        }}
        mode="multiple"
        value={value}
        disabled={disabled}
      >
        <Option value={null}>{""}</Option>
        <Option value={valueFull} disabled={checkFull}>
          <span>
            <CheckCircleOutlined
              style={{
                color: !checkFull ? "#0080CB" : "lightgray",
              }}
              className="mr5"
            />
            {textFull}
          </span>
        </Option>
        {renderOption(listSelect)}
      </Select>
    </div>
  );
};

export default SelectWithTagAll;
